import { ShoppingBag, ChevronRight } from 'lucide-react'

// Eine offene-Bestellung-Zeile in der Versand-Card.
// Subtext = Store-Name (Artikel-Anzahl ist nicht geladen → bewusst weggelassen).
export function OrderRow({ order, onClick }) {
  return (
    <div
      onClick={onClick}
      className="flex items-center gap-3 px-4 py-[13px] cursor-pointer active:scale-[0.99] transition-transform"
    >
      <div
        className="w-[34px] h-[34px] rounded-[9px] flex items-center justify-center flex-shrink-0"
        style={{ background: 'var(--tint-online)' }}
      >
        <ShoppingBag size={17} style={{ color: 'var(--accent-online)' }} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[14.5px] font-medium truncate">
          Bestellung #{order.bestellnummer}
        </div>
        {order.storeName && (
          <div className="text-[12px] text-[var(--label-tertiary)] mt-px truncate">
            {order.storeName}
          </div>
        )}
      </div>
      <ChevronRight size={17} className="text-[var(--label-tertiary)] flex-shrink-0" />
    </div>
  )
}
